"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _connectedReactRouter = require("connected-react-router");

var _reactRouter = require("react-router");

var _securedRoute = _interopRequireDefault(require("./securedRoute"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Router = function Router(props) {
  return _react.default.createElement(_connectedReactRouter.ConnectedRouter, {
    history: props.history
  }, _react.default.createElement(_reactRouter.Switch, null, props.routes.map(function (route, index) {
    return _react.default.createElement(_reactRouter.Route, {
      component: route.secured ? (0, _securedRoute.default)(route.component, route.redirectPath) : route.component,
      exact: true,
      key: index,
      path: route.path
    });
  }), _react.default.createElement(_reactRouter.Route, {
    component: props.noMatchComponent
  })));
};

var _default = Router;
exports.default = _default;